/* tslint:disable */

import React from 'react';

interface IBusIconProps {
    height: string;
    isWithoutBox: boolean;
}

const busIcon: React.SFC<IBusIconProps> = props => {
    const icon = (
        <svg
            className='line-icon'
            version='1.1'
            id='Layer_1'
            x='0px'
            y='0px'
            viewBox='0 0 16 16'
            enableBackground='new 0 0 16 16'
            height={props.height}
        >
            <path
                fill='#FFFFFF'
                d='M13.663 15.52H2.462c-1.06 0-1.92-0.86-1.92-1.92V2.399c0-1.06 0.86-1.92 1.92-1.92h11.201
    c1.06 0 1.92 0.86 1.92 1.92V13.6C15.583 14.66 14.723 15.52 13.663 15.52z'
            />
            <g>
                <path
                    fill='#007AC9'
                    d='M0 1.98C0 0.9 0.9 0 1.98 0h12C15.1 0 16 0.9 16 1.98v12C16 15.1 15.1 16 13.98 16h-12
      C0.9 16 0 15.1 0 13.98V1.98z M8.02 1.72c-1.66 0-3.1 0.08-4.68 0.3C2.86 2.08 2.58 2.36 2.58 2.78v9.36c0 0.3 0.22 0.5 0.42 0.56
      l0.6 0.1v1.26c0 0.14 0.12 0.24 0.28 0.24h0.96c0.12 0 0.24-0.1 0.24-0.24v-1.12c0.78 0.1 1.84 0.14 2.9 0.14
      c1.08 0 2.18-0.04 2.94-0.14v1.12c0 0.14 0.14 0.24 0.26 0.24h0.96c0.16 0 0.28-0.1 0.28-0.24V12.8l0.6-0.1
      c0.22-0.06 0.42-0.24 0.42-0.56V2.78c0-0.42-0.28-0.7-0.76-0.76C11.08 1.82 9.62 1.72 8.02 1.72z M12.16 9.7
      c-1.14 0.2-2.64 0.4-4.1 0.4c-1.54 0-3-0.18-4.16-0.44C3.58 9.6 3.46 9.48 3.46 9.22V3.38c0-0.26 0.12-0.44 0.44-0.44l8.26 0.04
      c0.32 0 0.42 0.18 0.42 0.44v5.84C12.58 9.52 12.48 9.66 12.16 9.7z M3.78 11.3c0.02-0.26 0.26-0.5 0.54-0.5
      c0.28 0 0.52 0.24 0.52 0.5c0 0.3-0.24 0.54-0.52 0.54C4.02 11.82 3.78 11.58 3.78 11.3z M11.1 11.3c0.02-0.26 0.26-0.5 0.52-0.5
      c0.28 0 0.52 0.24 0.52 0.5c0 0.3-0.24 0.54-0.52 0.54C11.34 11.82 11.1 11.58 11.1 11.3z'
                />
            </g>
        </svg>
    );

    const iconWithoutBox = (
        <svg
            className='line-icon'
            version='1.1'
            id='Layer_1'
            x='0px'
            y='0px'
            viewBox='0 0 1024 1024'
            enableBackground='new 0 0 16 16'
            height={props.height}
        >
            <g>
                <path
                    fill='#FFFFFF'
                    d='M954.633 86.277v761.906c0 26.050-16.282 40.702-34.189 45.586l-48.841 8.139v102.563c0 11.397-9.765 19.536-22.791 19.536h-78.142c-9.768 0-21.162-8.139-21.162-19.536v-91.169c-61.868 8.139-151.407 11.397-239.321 11.397-86.285 0-172.566-3.255-236.059-11.397v91.169c0 11.397-9.768 19.536-19.536 19.536h-78.146c-13.023 0-22.791-8.139-22.791-19.536v-102.563l-48.841-8.139c-16.282-4.884-34.189-21.166-34.189-45.586v-761.906c0-34.189 22.791-56.98 61.868-61.864 128.609-17.911 245.827-24.421 380.953-24.421 130.242 0 249.086 8.139 379.327 24.421 39.069 4.884 61.86 27.675 61.86 61.864zM884.63 138.373c0-21.166-8.139-35.818-34.189-35.818l-672.366-3.255c-26.050 0-35.818 14.652-35.818 35.814v475.38c0 21.162 9.768 30.93 35.818 35.814 94.424 21.166 213.268 35.814 338.625 35.814 118.844 0 240.947-16.282 333.741-32.559 26.050-3.255 34.189-14.652 34.189-35.814v-475.376zM254.588 779.806c0-21.162-19.533-40.698-42.324-40.698-22.795 0-42.328 19.536-43.957 40.698 0 22.795 19.536 42.328 43.957 43.957 22.791 0 42.324-19.536 42.324-43.957zM848.812 779.806c0-21.162-19.533-40.698-42.328-40.698-21.162 0-40.695 19.536-42.324 40.698 0 22.795 19.533 42.328 42.324 43.957 22.795 0 42.328-19.536 42.328-43.957z'
                />
            </g>
        </svg>
    );

    return props.isWithoutBox ? iconWithoutBox : icon;
};

export default busIcon;
